module.exports = __webpack_public_path__ + "img/hello-china.efedaff2.png";